import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import withStyles from 'react-jss'
import { withRouter } from 'react-router'

const styles = theme => ({
  breadcrumbGeneral: {
    color: theme.breadcrumb.color
  },
  breadcrumbNotActive: {
    color: theme.breadcrumb.color,
    '&:hover': {
      color: theme.breadcrumb.colorHover
    }
  },
  breadcrumbActive: {
    color: theme.breadcrumb.colorActive
  }
})

const BreadcrumbItem = ({
  position,
  to,
  active,
  isLast,
  classes,
  styleGeneral,
  styleActive,
  styleNotActive,
  children,
  location
}) =>
  !active ? (
    <Fragment>
      <span
        itemProp='itemListElement'
        itemScope
        itemType='https://schema.org/ListItem'
      >
        <meta itemProp='position' content={position} />
        <Link
          to={to}
          className={`${classes.breadcrumbNotActive} ${styleNotActive || ''}`}
          itemProp='item'
        >
          <span itemProp='name'>{children}</span>
        </Link>
      </span>
      {!isLast ? (
        <span className={`${classes.breadcrumbGeneral} ${styleGeneral || ''}`}>
          {' > '}
        </span>
      ) : (
        ''
      )}
    </Fragment>
  ) : (
    <Fragment>
      <span
        itemProp='itemListElement'
        itemScope
        itemType='https://schema.org/ListItem'
      >
        <meta itemProp='position' content={position} />
        <Link
          to={to || location.pathname}
          className={`${classes.breadcrumbActive} ${styleActive || ''}`}
          itemProp='item'
        >
          <span itemProp='name'>{children}</span>
        </Link>
      </span>
      {!isLast ? (
        <span className={`${classes.breadcrumbGeneral} ${styleGeneral || ''}`}>
          {' > '}
        </span>
      ) : (
        ''
      )}
    </Fragment>
  )

BreadcrumbItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.any.isRequired,
  to: PropTypes.string
}

export default withRouter(withStyles(styles)(BreadcrumbItem))
